let blogData = [
  {
    id: 1,
    name: '10 Common Things You Should Know ',
    description: 'That’s not all about string but these 10 things...',
    image: 'https://i.ibb.co/vHzkdbW/0-0-WJDi063h-Z1-MAt-Z2-1.jpg',
    blogLink: 'https://reya3183.medium.com/some-important-topics-of-javascript-69df71b87f4f'
  },
  {
    id: 2,
    name: 'Let’s Fun With React-Reveal',
    description: 'Do you want to create animation in your react project?..',
    image: 'https://i.ibb.co/tc5JmXJ/1-E-a-Is-LUu6vi-O7-IApk5-ILSA-1.png',
    blogLink: 'https://reya3183.medium.com/lets-fun-with-react-reveal-98641be3321d'
  },
  {
    id: 3,
    name: 'Error Handling in JavaScript',
    description: 'If you are a programmer and when you run code...',
    image: 'https://i.ibb.co/p12N8R6/error-101407-640-1.jpg',
    blogLink: 'https://reya3183.medium.com/error-handling-in-javascript-901dad20bd77'
  }

]
export default blogData;